import './ModalContainer.scss';
import React, { useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { classNames } from 'primereact/utils';

function ModalContainer(props) {
  const { children, visible, className, ...restProps } = props
  const modalContainerRef = useRef(null)

  return (
    <div className={classNames('ModalContainer', className)} ref={modalContainerRef}>
      <Dialog visible={visible} appendTo={modalContainerRef.current} {...restProps} >
        {children}
      </Dialog>
    </div>
  )
}

ModalContainer.defaultProps = {
  visible: false
}

export default ModalContainer;
